import { NavigationProvider, useModal } from "@/packages";
import {
    LOCAL_STORAGE,
    useSetBookingRecoilState,
    useSetBookingYeogiRecoilState,
    useSetToggleState,
} from "@/shared/client";
import { useGetBaseInfo, type BaseInfoResponse } from "@/shared/server";
import { insertGoogleAnalytics } from "@/utils";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Footer } from "./footer";
import { Header } from "./header";

export const Layout = () => {
    const { data } = useGetBaseInfo<BaseInfoResponse>();
    const { isPrivate, logoUrl, navigation, pensionInfo, ga, bookingUrl, ybs, yeogi } = { ...data };
    const { pathname } = useLocation();
    const { closeModal } = useModal();
    const setToggleState = useSetToggleState();
    const setBookingEngineState = useSetBookingRecoilState();
    const setBookingYeogi = useSetBookingYeogiRecoilState();

    // const setVimeoState = useSetVimeoState();
    useEffect(() => {
        window.scrollTo(0, 0);
        setToggleState(false);
        closeModal();
    }, [pathname]);

    useEffect(() => {
        if (pensionInfo) {
            if (ga?.head) insertGoogleAnalytics(ga);
            LOCAL_STORAGE.set({ key: "pensionName", value: `${pensionInfo.name.kr}` });

            if (bookingUrl) {
                const isGoogleBE = bookingUrl.includes("booking-engine");
                setBookingEngineState({ isGoogleBE, bookingUrl });
            }
            if (yeogi) {
                setBookingYeogi(yeogi);
            }
        }
        // if (vimeo) {
        //     setVimeoState(vimeo);
        // }
    }, [pathname, ga]);
    const navigationData = {
        navigation: {
            roomList: data?.navigation.roomList || [],
            specialList: data?.navigation.specialList || [],
        },
    };

    const isVerticalSlidePages = !pathname.includes("/reserve") && !pathname.includes("/guide");

    return (
        <>
            <Header navigation={navigation} logoUrl={logoUrl} pensionInfo={pensionInfo} />
            {isVerticalSlidePages ? (
                <NavigationProvider value={navigationData}>
                    <Outlet />
                </NavigationProvider>
            ) : (
                <>
                    <NavigationProvider value={navigationData}>
                        <Outlet />
                    </NavigationProvider>
                    <Footer isPrivate={isPrivate} logoUrl={logoUrl} pensionInfo={pensionInfo} ybs={ybs} yeogi={yeogi} />
                </>
            )}
        </>
    );
};
